import CommonEdit from '@/components/common/Edit';
import axiosInstance from '@/utils/axiosInstance';
import { singleProp } from '@/interface/dataInterface';
import { FC, useEffect, useState } from 'react';
import PartnersForm from './PartnersForm';
import { PartnerData } from '@/interface/entityInterface';

const PartnerEdit: FC<singleProp> = ({prop}) => {
    const [formProp, setFormProp] = useState({
        firstname: "",
        lastname: "",
        email: "",
        phone: "",
        percentage_commission: 0,
    });

    useEffect(() => {
        if (!prop) return;
        const getPartner = async () => {
            const {data} = await axiosInstance.get<PartnerData>(`/referral-agents/${prop}`)
            const {percentage_commission, user, phone} = data
            const {firstname, lastname, email} = user
            setFormProp({firstname, lastname, email, phone, percentage_commission})
        }

        getPartner()
    }, [prop])

    return (
        <CommonEdit title='Edit' id={prop} resource='referral-agents' data={{...formProp, phone: String(formProp.phone), password: "1"}}>
            <PartnersForm formProp={formProp} setFormProp={setFormProp} mode='edit'/>
        </CommonEdit>
    )
};

export default PartnerEdit;